import { loadable } from '../../components/Loadable/index';

export const LoadableSubscriptionsAdmin = loadable(
  () => import('./connector'),
  {
    resolveComponent: (mod) => mod.ConnectedSubscriptionsAdmin,
  }
);
